import Translations from 'src/core/utils/Translations';
import { useBathCardsStore } from 'src/domain/stores/useBathCardsStore';
import { isBathCardDepleted } from 'src/presentation/components/organisms/BathCardCard';
import ConfirmationDialog from 'src/presentation/dialogs/ConfirmationDialog';

const RemoveBathCardDialog = () => {
	const { removeCard, isRemoveCardDialogVisible, isRemovingCard, confirmRemoveCard, setRemoveCardDialogVisible } =
		useBathCardsStore();

	if (removeCard === null) {
		return null;
	}

	const isUnlink = !isBathCardDepleted(removeCard);

	return (
		<ConfirmationDialog
			buttonTextClaim={isUnlink ? Translations.bathcardUnlink : Translations.delete}
			isLoading={isRemovingCard}
			text={isUnlink ? Translations.bathcardAreYouSureUnlinkBathcard : Translations.bathcardAreYouSureDeleteBathcard}
			visible={isRemoveCardDialogVisible}
			onPress={() => setRemoveCardDialogVisible(false)}
			onPressClaim={() => confirmRemoveCard()}
		/>
	);
};

export default RemoveBathCardDialog;
